export default __webpack_public_path__ + "img/593d4c78bdcb6b4fbc456b50eefc8fda.png";